import { Injectable, Signal } from '@angular/core';

@Injectable()
export abstract class RtlProvider {
  rtl: Signal<boolean>;
}
